import { render } from "./ConfirmUnsubscribe.vue?vue&type=template&id=180e041d&scoped=true"
import script from "./ConfirmUnsubscribe.vue?vue&type=script&lang=js"
export * from "./ConfirmUnsubscribe.vue?vue&type=script&lang=js"

import "./ConfirmUnsubscribe.vue?vue&type=style&index=0&id=180e041d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180e041d"]])

export default __exports__